import React from "react";
import SurveyFormUnitCsdFeesTable from "./SurveyFormUnitCsdFeesTable";

/* See ../hack.html for explicit references to min-h-1 etc. so tailwindcss watch will generated those styles */

const SurveyFormUnitCsdFees = ({ isInfoOnFeesAvailable, showModal, width, onModalClose }) => {
  return (
    <>
      <div className="modal-container">
        {showModal && (
          <div className="modal fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center">
            <div className="modal-content bg-white p-4 rounded">
              <SurveyFormUnitCsdFeesTable
                width={width}
                onModalClose={onModalClose}
              />
            </div>
          </div>
        )}
      </div>
      {isInfoOnFeesAvailable && (
        <div className="hidden print:block">
          <SurveyFormUnitCsdFeesTable
            width={width}
          />
        </div>
      )}
    </>
  );
};

export default SurveyFormUnitCsdFees;
